import { Dropdown as BaseDropdown, DropdownType } from '@beef/ui-kit';
import { withClassName } from '@beef/shop-common';

export const Dropdown = withClassName<DropdownType>(BaseDropdown);
